
import template from './add_virtual_machine_dialog.html';

var AddVMViewModel = function(page)
{
	var self = this;
	self.page = page;

	this.sites = ko.observableArray();
	this.disk_sizes = ko.observableArray();
	this.ram_sizes = ko.observableArray();
	this.vcpu_options = ko.observableArray([{'vcpu' : 1},{'vcpu' : 2}]);

	this.virtual_machine_name = ko.observable();
	this.site_id = ko.observable();
	this.site_name = ko.observable();
	this.site_location = ko.observable();
	this.site_ip = ko.observable();
	this.disk_size = ko.observable();
	this.ram_size = ko.observable();
	this.vcpu = ko.observable();
}

var AddVMClass = function(bindings)
{
	var self = this;
	this.self = self;
	this.bindings = bindings;
	this.viewModel = new AddVMViewModel(this);
	this.name = 'Add Virtual Machine';

	this.init = function() {
		
		$.postJSON("/grape/list", {schema:'account', tablename: 'sites', sortfield: 'site_name', sortorder: 'desc', }, function (res) {
			self.viewModel.sites(res.records);
		});

		$.postJSON("/grape/list", {schema:'account', tablename: 'disk_sizes', sortfield: 'disk_size', sortorder: 'desc',  }, function (res) {
			self.viewModel.disk_sizes(res.records);
		});

		$.postJSON("/grape/list", {schema:'account', tablename: 'ram_sizes',sortfield: 'ram_size', sortorder: 'desc', }, function (res) {
			self.viewModel.ram_sizes(res.records);
		});
	};

	this.add_vm = function() {
		
		$.postJSON('/installation/add_virtual_machine', {	virtual_machine_name:  document.getElementById('txtvirtual_machine_name').value,
			site_id :self.viewModel.site_id(),
			site_name:self.viewModel.site_name(),
			site_location : self.viewModel.site_location() ,
			site_ip :self.viewModel.site_ip(),
			disk_size : document.getElementById('ddlDiskSize').value ,
			disk_ram : document.getElementById('ddlRamSize').value,
			vcpu : document.getElementById('ddlVcpu').value}, function(res) {
			self.close(false);
		});
	};

	this.onClose = function() { 
	};

	this.btnclose = function() {
		self.close(false);
	};


	//Site Drop Down Change Event
	$('#ddlSites').change(function () {
		let value = $(this).val();
		if (value) {
			$.postJSON("/grape/list", {schema:'account', tablename: 'sites', sortfield: 'site_name', sortorder: 'desc',filter: [{ value: value, op: '=', field: 'site_id' }] }, function (res) {
				self.viewModel.site_id(res.records[0].site_id);
				self.viewModel.site_name(res.records[0].site_name);
				self.viewModel.site_location(res.records[0].site_location);
				self.viewModel.site_ip(res.records[0].site_ip);
			});
		}
	});	
}

//Register the dialog
export default {
	name: 'AddVM',
	dialog_class: AddVMClass,
	template: template
};

